import { SharedFeature } from '@com-delta-idp/mnx-skymiles-shared';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { getPartners as adaptPartners } from '../../adapters/partners.adapter';
import { PartnersPersonalizationEngineRequest } from '../../models/partners-personalization-engine.interfaces';

import { Params } from '../../models/partners.constants';
import {
  PARTNERS_FEATURE_KEY,
  partnersAdapter,
  State
} from '../reducers/partners.reducer';

// Lookup the 'Shared' feature state managed by NgRx
export const getSharedState = createFeatureSelector<SharedFeature.State>(
  SharedFeature.SHARED_FEATURE_KEY
);

const { selectEntities: selectSharedEntities } =
  SharedFeature.sharedAdapter.getSelectors();

export const getSharedEntities = createSelector(
  getSharedState,
  (state: SharedFeature.State) => {
    return selectSharedEntities(state);
  }
);

// Lookup the 'Partners' feature state managed by NgRx
export const getPartnersState =
  createFeatureSelector<State>(PARTNERS_FEATURE_KEY);
const { selectEntities } = partnersAdapter.getSelectors();

export const getPartnersError = createSelector(
  getPartnersState,
  (state: State) => state.error
);

export const getPartnersEntities = createSelector(
  getPartnersState,
  (state: State) => selectEntities(state)
);

export const getPartners = createSelector(
  getSharedEntities,
  getPartnersEntities,
  (sharedEntities, partnersEntities) =>
    adaptPartners(
      partnersEntities['partners-promotions-content']
        ?.partnersPromotionsContent,
      partnersEntities['partners-content']?.partnersContent,
      true, // Parent component has check whether partners feature is enabled
      [partnersEntities['partners-content-error']?.partnersContentError],
      partnersEntities['aem-error-messages']?.errorMessagesContent
    )
);

// TODO(ARUN): Create json for static content and error message and form the request
export const getPartnerRequest = createSelector(
  getSharedEntities,
  (sharedEntities) => {
    const request: PartnersPersonalizationEngineRequest = {
      requestparam: {
        campaignId: Params.CAMPAIGN_ID,
        format: Params.FORMAT
      },
      userdata: {
        membershipLevel:
          sharedEntities['user-session']?.userSession?.membershipLevel
      }
    };
    return request;
  }
);
